import { render, staticRenderFns } from "./EmploymentHistory.vue?vue&type=template&id=2572d572"
import script from "./EmploymentHistory.vue?vue&type=script&lang=js"
export * from "./EmploymentHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports